import { appUrls } from "../../utils/urls/appUrls";

import {
  // Dashboard,
  CertificateManagement,
  SearchResult,
  // DigitalLetter,
  CertificateView,
  // ProfileCreation,
  // ProfileCompletionSuccess,
  // UserProfile,
  // PrintLetter,
  // EvaluationHistory
} from "../../app/pages";
// import OTPVerification from '../../app/pages/CertificateManagement/BankRep/OTPVerification'
// import LinkVerificationError from '../../app/pages/CertificateManagement/BankRep/LinkVerificationError'
import TransactionHistory from "../../app/pages/CertificateManagement/TransactionHistory";

export const bankRoutes = [
  // {
  // 	url: appUrls.dashboard,
  // 	component: <Dashboard />,
  // 	routeType: 'private'
  // },
  {
    url: appUrls.bank_certificates,
    component: <CertificateManagement />,
    routeType: "private",
  },
  // {
  // 	url: appUrls.upload_certificate_of_reasonableness,
  // 	component: <OTPVerification />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.upload_link_verification_error,
  // 	component: <LinkVerificationError />,
  // 	routeType: 'private'
  // },
  {
    url: appUrls.bank_certificates_search,
    component: <SearchResult />,
    routeType: "private",
  },
  {
    url: appUrls.bank_certificates_view,
    component: <CertificateView />,
    routeType: "private",
  },
  {
    url: appUrls.bank_transaction_history,
    component: <TransactionHistory />,
    routeType: "private",
  },
  // {
  // 	url: appUrls.digital_letters,
  // 	component: <DigitalLetter />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.profileCreation,
  // 	component: <ProfileCreation />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.profileCreationSuccess,
  // 	component: <ProfileCompletionSuccess />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.user_profile,
  // 	component: <UserProfile />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.print,
  // 	component: <PrintLetter />,
  // 	routeType: 'private'
  // },
];
